import { iconSetAlpine } from 'ag-grid-community';
import { themeQuartz } from '@ag-grid-community/theming';

/** Dark list theme for the work-products AgGridReact (app AG Grid 32). */
export const workProductGridTheme = themeQuartz.withPart(iconSetAlpine).withParams({
  accentColor: '#FFFFFF54',
  backgroundColor: '#0F1D32',
  borderColor: '#FFFFFF12',
  borderRadius: 20,
  browserColorScheme: 'dark',
  cellHorizontalPaddingScale: 0.5,
  checkboxBorderRadius: '3px',
  chromeBackgroundColor: {
    ref: 'backgroundColor',
  },
  columnBorder: false,
  fontFamily: 'inherit',
  fontSize: '14px',
  foregroundColor: '#FCFCFC',
  headerBackgroundColor: '#09121E',
  headerFontSize: 16,
  headerFontWeight: 500,
  headerTextColor: '#FFFFFF',
  headerVerticalPaddingScale: 0.5,
  headerColumnResizeHandleColor: '#FFFFFF12',
  headerColumnResizeHandleWidth: 3,
  headerColumnResizeHandleHeight: 20,
  iconSize: '16px',
  inputBorder: false,
  inputBorderRadius: '0px',
  inputFocusBackgroundColor: '#FFFFFF00',
  inputFocusBorder: false,
  inputFocusShadow: '#0000002A 0px 0px 0px 3px',
  inputFocusTextColor: '#292A2C',
  inputTextColor: '#060606',
  oddRowBackgroundColor: '#FFFFFF10',
  rowBorder: false,
  rowVerticalPaddingScale: 0.5,
  sidePanelBorder: true,
  spacing: 8,
  wrapperBorder: true,
  wrapperBorderRadius: '7px',
});
